import styles from './AppTableStatus.module.scss'

const AppTableStatus = (props) => {
  const { withDot, className, text, color, type = 'TAG', onClick } = props
  return (
    <div
      className={`${
        type === 'TAG'
          ? styles.tableStatus
          : 'text-danger underline underline-offset-2 cursor-pointer'
      } ${styles[color] || ''} ${className || ''}`}
      onClick={onClick}
    >
      {withDot ? <span></span> : null}
      {text}
    </div>
  )
}

export default AppTableStatus
